import React, { Component, useState } from "react";
import { APIProvider, Map, Marker, AdvancedMarker, Pin, InfoWindow, MapCameraChangedEvent } from '@vis.gl/react-google-maps';
import nosotros from '../../assets/nosotros.png'

const Maps = ({ lat, lng, listing }) => {
    const y = parseFloat(lat)
    const x = parseFloat(lng)
    const [open, setOpen] = useState(false);
    const [selectedPosition, setSelectedPosition] = useState(null);
    const mainPosition = { lat: y, lng: x };

    const position = { lat: y, lng: x }
    const locations = [
        { lat: "4.65103259", lng: "-74.05405573" },
        { lat: "4.65092137", lng: "-74.05409913" },
    ];

    return (
        <APIProvider apiKey={"AIzaSyAiaT-WEhevWJziUSsuNH-SgM00Y3cXp-M"}>
            <div style={{ height: "80vh", width: "100%" }}>
                <Map
                    style={{
                        width: '100%',
                        height: '100%',
                    }}
                    defaultCenter={position}
                    defaultZoom={18}
                >
                    {/* Marker principal con ícono personalizado */}
                    <Marker
                        position={position}
                        icon={{
                            url: nosotros,
                            scaledSize: { width: 40, height: 40 },
                        }}
                        onClick={() => { setOpen(true) }}
                    />


                    {open && (
                        <InfoWindow position={position} onCloseClick={() => setOpen(false)}>
                            <div
                                style={{
                                    maxWidth: "220px",
                                    display: "flex",
                                    flexDirection: "column",
                                    fontFamily: "Arial, sans-serif",
                                    paddingTop: "1px"
                                }}
                            >
                                {listing.listingImages?.[0]?.url && (
                                    <img
                                        src={listing.listingImages[0].url}
                                        alt={listing.name}
                                        style={{
                                            width: "100%",
                                            height: "120px",
                                            objectFit: "cover",
                                            borderRadius: "6px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                )}
                                <p
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        margin: "0 0 2px 0",
                                        lineHeight: "1.2",
                                         marginBottom: "10px",
                                    }}
                                >
                                    {listing.name}
                                </p>
                                <p
                                    style={{
                                        fontSize: "13px",
                                        color: "#333",
                                        margin: 0,
                                         marginBottom: "5px",
                                    }}
                                >
                                    {listing.city}
                                </p>
                            </div>
                        </InfoWindow>
                    )}

                </Map>
            </div>
        </APIProvider>
    );
}

export default Maps;
